import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { ScrollableList } from './ScrollableList.js';
import { useListbox } from './useListbox.js';
import { useMultiListbox } from './useMultiListbox.js';

var _excluded = ["className"],
    _excluded2 = ["className"];
var Listbox = /*#__PURE__*/forwardRef(function Listbox(props, ref) {
  var externalClassName = props.className,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useListbox = useListbox(otherProps, ref),
      list = _useListbox.list,
      input = _useListbox.input;

  var className = cn('yt-listbox', externalClassName);
  return createElement("span", {
    className: className
  }, createElement(ScrollableList, Object.assign({}, list)), createElement("input", Object.assign({}, input, {
    type: "text"
  })));
});
var MultiListbox = /*#__PURE__*/forwardRef(function Listbox(props, ref) {
  var externalClassName = props.className,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded2);

  var _useMultiListbox = useMultiListbox(otherProps, ref),
      list = _useMultiListbox.list,
      input = _useMultiListbox.input;

  var className = cn('yt-listbox', externalClassName);
  return createElement("span", {
    className: className
  }, createElement(ScrollableList, Object.assign({}, list)), createElement("input", Object.assign({}, input, {
    type: "text"
  })));
});

export { Listbox, MultiListbox };
//# sourceMappingURL=Listbox.js.map
